/**
 * Energy-availability signal surface (T19.6 / ADR-0030 §5 — HIGH-CARE, ED-gated).
 *
 * Gentle, non-clinical, non-alarming. NEVER a diagnosis. Renders only when the
 * server says `active` (double-locked off by default — see ADR-0030 §5b). Calm
 * neutral styling (no red, no alarm), reuses the existing ED-resource link, and
 * offers a one-tap opt-out so it never nags.
 */
import { useTranslation } from 'react-i18next';
import { useCycleConsent, useEnergySignal, useOptOutEnergySignal } from '../hooks/useCycle.js';

export function EnergyAvailabilityNotice() {
  const { t } = useTranslation('cycle');
  const { data: consents } = useCycleConsent();
  const hasCycleConsent =
    consents?.consents?.some((c) => c.purpose === 'cycle' && c.granted) ?? false;

  const { data: signal } = useEnergySignal(hasCycleConsent);
  const optOut = useOptOutEnergySignal();

  if (!hasCycleConsent || !signal?.active) return null;

  return (
    <div className="mt-6 rounded-2xl border border-husk bg-paper px-5 py-4">
      <p className="text-sm leading-6 text-ink">{t('signal.body')}</p>
      {signal.resourceUrl && (
        <a
          href={signal.resourceUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-3 inline-block text-sm font-medium text-leaf underline"
        >
          {t('signal.resources')}
        </a>
      )}
      <button
        type="button"
        onClick={() => optOut.mutate()}
        disabled={optOut.isPending}
        className="mt-3 block text-xs text-ink-soft underline"
      >
        {t('signal.dismiss')}
      </button>
    </div>
  );
}
